import { getVariantHistory, getSupplierWarehouses } from './api/suppliers';
import { alertError } from './alert';

import { setWarehouses } from './warehouses';

import {
  HISTORY_LOG_VARIANT,
  HISTORY_LOG_DATA,
  HISTORY_LOG_COUNT,
  HISTORY_LOG_TOGGLE_MODAL,
  HISTORY_LOG_OFFSET,
  HISTORY_LOG_PER_PAGE,
  HISTORY_LOG_LOADING,
} from '../constants/historyLogTypes';
import { getTotalCountHeader } from './api/utils';

export const setInventoryHistoryVariant = (data) => ({ type: HISTORY_LOG_VARIANT, payload: data });
export const setInventoryHistoryData = (data) => ({ type: HISTORY_LOG_DATA, payload: data });
export const setInventoryHistoryCount = (count) => ({ type: HISTORY_LOG_COUNT, payload: count });
export const inventoryHistoryToggleModal = (open = true) => ({ type: HISTORY_LOG_TOGGLE_MODAL, payload: open });
export const setInventoryLogsLoading = (isLoading) => ({ type: HISTORY_LOG_LOADING, payload: { isLoading } });

export const getInventoryHistoryLog = () => async (dispatch, getState) => {
  const state = getState();
  const { variant, perPage, offset, count } = state.historyLog;
  const { supplierId } = state.role;
  let { data: warehouses } = state.warehouses;

  try {
    if (!warehouses.length) {
      const warehousesResponse = await getSupplierWarehouses(supplierId);
      if (warehousesResponse.data) {
        warehouses = warehousesResponse.data;
        dispatch(setWarehouses(warehouses));
      }
    }

    if (!warehouses.length) {
      dispatch(alertError('Supplier has no warehouses'));
      return;
    }

    const warehousesNames = warehouses.reduce((names, warehouse) => {
      names[warehouse.id] = warehouse;
      return names;
    }, {});

    dispatch(setInventoryLogsLoading(true));
    const response = await getVariantHistory(variant.id, offset, perPage);
    if (response && response.data) {
      const data = response.data.map((entry) => {
        entry.warehouse_name = warehousesNames[entry.warehouse_id].name;
        return entry;
      });

      const newCount = getTotalCountHeader(response);

      if (count !== newCount) {
        dispatch(setInventoryHistoryCount(newCount));
      }

      dispatch(setInventoryHistoryData(data));
    } else {
      dispatch(alertError('Variant has no history'));
    }
  } catch (error) {
    dispatch(alertError(error));
  } finally {
    dispatch(setInventoryLogsLoading(false));
  }
};

export const setInventoryHistoryOffset = (offset) => (dispatch) => {
  dispatch({ type: HISTORY_LOG_OFFSET, payload: offset });
  dispatch(getInventoryHistoryLog());
};

export const setInventoryHistoryPerPage = (perPage) => (dispatch) => {
  dispatch({ type: HISTORY_LOG_PER_PAGE, payload: perPage });
  dispatch(getInventoryHistoryLog());
};
